import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import webservice from '../../Queries/webservice';
import getCookie from '../../Queries/getCookie';

// Components
import Alert from '../../Alert';
import TableComponent from '../../TableComponent';
import SectionTitle from '../../SectionTitle';
import OrderCard from '../../OrderCard';

// Dependencies
import getParcelTrackingQuerie from '../../Queries/getParcelTracking';
import getEmbarques from '../../Queries/getEmbarques';

// Styles
import styles from './index.module.sass';

const Shipments = (props) => {
  const { device, adminWebservice, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('shipments');
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [openTracking, setOpenTracking] = useState(false);
  const [loading, setLoading] = useState(false);
  const [historyTracking, setHistoryTracking] = useState([]);
  const [statusTracking, setStatusTracking] = useState('');
  const location = process.env.REACT_APP_COUNTRY;
  const tableFields = t('tableHeader', { returnObjects: true });
  const tableFieldsModal = t('tableHeaderModal', { returnObjects: true });

  const idioma = window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1;

  function createEstafeta(history, status) {
    setLoading(true);
    let historyTmp = [];
    for (let i = 0; i < history.length; i++) {
      const tmp = history[i].split(',');
      historyTmp.push({
        date: tmp[0] || '',
        state: (tmp.length > 3 && tmp[3]) || '',
        movement: (tmp.length > 1 && tmp[1]) || '',
      });
    }
    setHistoryTracking(historyTmp);
    setStatusTracking(
      (status === 'EN_TRANSITO' && 'En transito') ||
        (status === 'CONFIRMADO' && 'Entregado') ||
        (status === 'DEVOLUCION' && 'Devolución') ||
        '',
    );
    setLoading(false);
  }

  function createDHL(history, status) {
    setLoading(true);
    let historyTmp = [];
    for (let i = 0; i < history.length; i++) {
      let tmpData = history[i].substring(history[i].indexOf(' ') + 1);
      tmpData = tmpData.substring(tmpData.indexOf(' ') + 1);
      tmpData = tmpData.substring(tmpData.indexOf(' ') + 1);

      const tmpHistory = history[i].split(' ');
      historyTmp.push({
        date: `${(tmpHistory.length > 0 && tmpHistory[0]) || ''} ${
          (tmpHistory.length > 1 && tmpHistory[1]) || ''
        }`,
        state: '',
        movement: tmpData,
      });
    }
    setHistoryTracking(historyTmp);
    setStatusTracking(status);
    setLoading(false);
  }

  const getParcelTracking = useCallback(
    async ({ parcel, guide }) => {
      setLoading(true);
      setOpenTracking(true);
      const response = await getParcelTrackingQuerie(
        adminWebservice,
        webservice,
        getCookie,
        parcel,
        guide,
      );
      const { tipoMensaje = 'error', history = [], status = '', typeMessage = 'error' } = response;
      if ((tipoMensaje === 'exito' || typeMessage === 'Success') && history.length > 0) {
        if (parcel === 'Estafeta') createEstafeta(history, status);
        if (parcel === 'DHL') createDHL(history, status);
        if (parcel === 'Paquete Express') createPaqueteExpress(history, status);
      }
      setLoading(false);
    },
    [adminWebservice],
  );

  function createPaqueteExpress(history, status) {
    setLoading(true);
    let historyTmp = [];
    for (let i = 0; i < history.length; i++) {
      let tmpData = history[i].substring(history[i].indexOf(' ') + 1);
      tmpData = tmpData.substring(tmpData.indexOf(' ') + 1);
      tmpData = tmpData.substring(tmpData.indexOf(' ') + 1);
      tmpData = tmpData.substring(tmpData.indexOf(' ') + 1);
      tmpData = tmpData.substring(tmpData.indexOf(' ') + 1);
      tmpData = tmpData.substring(tmpData.indexOf(' ') + 1);

      const tmpHistory = history[i].split(' ');
      historyTmp.push({
        date: `${(tmpHistory.length > 0 && tmpHistory[0]) || ''} ${
          (tmpHistory.length > 0 && tmpHistory[1]) || ''
        } ${(tmpHistory.length > 1 && tmpHistory[2]) || ''} ${
          (tmpHistory.length > 2 && tmpHistory[3]) || ''
        } ${(tmpHistory.length > 3 && tmpHistory[4]) || ''} ${
          (tmpHistory.length > 4 && tmpHistory[5]) || ''
        }`,
        state: '',
        movement: tmpData,
      });
    }
    setHistoryTracking(historyTmp);
    setStatusTracking(status);
    setLoading(false);
  }

  const getEmbarquesFunction = useCallback(async () => {
    setLoading(true);
    const response = await getEmbarques(webservice, getCookie, idioma);
    const { pedidos = [], mensaje = '', tipoMensaje = 'error' } = response;
    setSessionMessage(mensaje);
    if (mensaje !== '' || tipoMensaje === 'error') {
      setAlertText(mensaje);
      setOpen(true);
    } else {
      const tmpArr = pedidos.map((val, key) => {
        const { paqueteria = '', guia = '', fechaEntrega = '', fechaEntregaEstimada = '' } = val;
        if (paqueteria === 'Estafeta' || paqueteria === 'DHL' || paqueteria === 'Paquete Express') {
          val.callbackArgs = { parcel: paqueteria, guide: guia };
          val.callback = getParcelTracking;
        }

        if (!fechaEntrega && !fechaEntregaEstimada) val.fechaEntrega = t('pendingDelivery');
        else if (!fechaEntrega && fechaEntregaEstimada)
          val.fechaEntrega = (
            <div>
              <span className={styles.estimated}>{t('estimated')}:</span> <br />
              {fechaEntregaEstimada}
            </div>
          );
        else
          val.fechaEntrega = (
            <div>
              <span className={styles.delivered}>{t('delivered')}:</span> <br />
              {fechaEntrega}
            </div>
          );

        return val;
      });
      setOrders(tmpArr);
    }
    setLoading(false);
  }, [setSessionMessage, getParcelTracking, idioma, t]);

  useEffect(() => {
    getEmbarquesFunction();
  }, [getEmbarquesFunction, location]);

  return (
    <div id={styles.shipments} className={`${styles[screenSize]} ${styles.shipments}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <div className={styles.container}>
        <SectionTitle title={t('title')} subtitle={t('subtitle')} />
        <OrderCard>
          <TableComponent
            screenSize={screenSize}
            tableData={orders}
            tableItems={(Array.isArray(tableFields) && tableFields) || []}
          />
        </OrderCard>
      </div>
      {openTracking && (
        <div className={styles.overlay}>
          <div onClick={() => setOpenTracking(false)} className={styles.overlayBackground}></div>
          <div className={styles.paper}>
            {loading && <div>Loading...</div>}
            {!loading && historyTracking.length < 1 && (
              <div>
                <div className={styles.paperTop}>
                  <div className={styles.status}>{t('notFound')}</div>
                  <div className={styles.paperClose} onClick={() => setOpenTracking(false)}>
                    X
                  </div>
                </div>
              </div>
            )}
            {!loading && historyTracking.length > 0 && (
              <div>
                <div className={styles.paperTop}>
                  <div className={styles.status}>
                    <span>Status: </span> {statusTracking}
                  </div>
                  <div className={styles.paperClose} onClick={() => setOpenTracking(false)}>
                    X
                  </div>
                </div>

                <TableComponent
                  screenSize={screenSize}
                  tableData={historyTracking}
                  tableItems={(Array.isArray(tableFieldsModal) && tableFieldsModal) || []}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Shipments;
